export default __webpack_public_path__ + "static/video2-a07fcf86dd1ce0e225f6db31e1a7a92e.mp4";